const hostname = {
  production: 'https://image.homecaremedical.co.nz',
  test: 'https://test-image.homecaremedical.co.nz',
};

const IMAGE_UPLOAD_LIMIT = 3;
const IMAGE_MAX_SIZE = 20000000;
const VIDEO_MAX_SIZE = 200000000;
const IMAGE_RESIZE_WIDTH = process.env.IMAGE_RESIZE_WIDTH || 1539;
const IMAGE_RESIZE_HEIGHT = process.env.IMAGE_RESIZE_HEIGHT || 905;
const ENV = process.env.REACT_APP_ENV || process.env.NODE_ENV;

console.log(`config (ENV): ${ENV}`);

module.exports = {
  ENV,
  IMAGE_UPLOAD_LIMIT,
  IMAGE_MAX_SIZE,
  VIDEO_MAX_SIZE,
  IMAGE_RESIZE_WIDTH,
  IMAGE_RESIZE_HEIGHT,
  gtmTrackingCode: 'GTM-5ZRCJ88',
  isTest: ENV === 'test',
  isProd: ENV === 'production',
  isDebug: ENV !== 'production' && ENV !== 'test',
  hostname: hostname[ENV] || 'http://localhost',
  port: process.env.PORT || 8080,
  etxtApiUrl: 'https://www.etxtservice.co.nz/api/3/sms/out',
  messageMediaAPIKey: 'SDFaeXpFbE1zTDBOOW83MTZoUjM6NlJFRTIwYU9BalcwcFJrMk1KMkpFMm5PRWVMSm5t',
  etxtApiKey:
    'eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiIyMDA0MDI5IiwiYnJldm8iOnRydWUsImlzcyI6InAiLCJwcmVmZXJyZWRfdXNlcm5hbWUiOiJldHh0XFxoY20td2ViIiwiaWF0IjoxNTY0MDIxMDAzLCJqdGkiOiIzV0t3R0E9PSJ9.zdBjWYJ5-y5MdvDeWmeftHr6ZK02XRWV8xkBbE8oTCU',
};
